import AccountTBDetails from "@/pages/accountTB/AccountTBDetails.vue"
import AccountTBPage from "@/pages/accountTB/AccountTBPage.vue";

export default [
  {
    path: '/accountTBdetails/:id',
    component: AccountTBDetails,
    props: true
  },
  {
    path: '/accountTB/',
    component: AccountTBPage,
    props: true
  }
]
